import Link from "next/link";
import { Heading, Rating, Text, ImageWrapper } from "ui-components";

import { PLACEHOLDER_IMAGE } from "@/src/constants/images";
import { OrganizationResponseEntity } from "@/src/hooks/api/generated";
import { getOrganizationImages } from "@/utils/organization";

import { OrganizationCardStats } from "./OrganizationCardStats";

interface IOrganizationCard {
  organization: OrganizationResponseEntity;
}

export function OrganizationCard({
  organization,
}: IOrganizationCard): JSX.Element {
  const { logoImageUrl, coverImageUrl } = getOrganizationImages(organization);

  return (
    <div className="w-full flex justify-center sm:w-1/2 lg:w-1/3 px-2.5 md:px-5 py-8">
      <Link
        href={`/organizations/${organization.slug}`}
        className="w-full h-[410px] cursor-pointer border border-transparent hover:border hover:border-black block  rounded-[10px]"
      >
        <div className="relative w-full aspect-[259/100]">
          <ImageWrapper
            src={coverImageUrl}
            placeholderUrl="/organization-cover-fallback.jpg"
            alt={`${organization.name} cover image`}
            className="rounded-t-[10px] object-cover"
            fill
            isCLDImage
          />
        </div>
        <div className="p-5 flex flex-col gap-2">
          <ImageWrapper
            src={logoImageUrl}
            placeholderUrl={PLACEHOLDER_IMAGE}
            width={68}
            height={68}
            alt={`${organization.name} logo image`}
            className="rounded-[10px] w-[68px] h-[68px] object-cover border"
            isCLDImage
          />
          <Heading variant="h2">{organization.name}</Heading>
          {organization.rating > 0 && <Rating rating={organization.rating} />}
          <Text variant="large">{organization.industry.name}</Text>
          {/* <Text className="line-clamp-2">{description}</Text> */}
          <div className="flex gap-3 justify-between">
            {!!organization?.amount_of_employees && (
              <OrganizationCardStats
                title="Employees"
                stats={organization?.amount_of_employees}
                sizeClass={
                  organization?.total_jobs > 0 &&
                  organization?.total_reviews > 0
                    ? "grow-[2]"
                    : "flex-1"
                }
              />
            )}
            {organization?.total_jobs > 0 && (
              <OrganizationCardStats
                title="Jobs"
                stats={organization.total_jobs}
              />
            )}
            {organization?.total_reviews > 0 && (
              <OrganizationCardStats
                title="Reviews"
                stats={organization.total_reviews}
              />
            )}
          </div>
        </div>
      </Link>
    </div>
  );
}
